module.exports = __webpack_public_path__ + "img/LATIN10_10.ee785e6a.jpg";